import { SignUpForm } from "@/components/sign-up-form";
import { usePageMeta } from "../use-page-meta";

export default function SignUpPage() {
  usePageMeta("/auth/sign-up", "회원가입");
  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <SignUpForm />
    </div>
  );
}
